import React, { useEffect, useState } from 'react';
import type { FileDeliveryState } from '../hooks/useFileDelivery';
import { useFileDelivery } from '../hooks/useFileDelivery';

export interface FileDeliveryNotificationProps {
  deliveryState?: FileDeliveryState;
}

export function FileDeliveryNotification({
  deliveryState: customState,
}: FileDeliveryNotificationProps) {
  const defaultDelivery = useFileDelivery();
  const delivery = customState ?? defaultDelivery;
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (delivery.status === 'done') {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
    setVisible(true);
  }, [delivery.status]);

  if (delivery.status === 'idle' || !visible) return null;

  return (
    <div
      className="file-delivery-toast"
      role="status"
      data-testid="file-delivery-toast"
    >
      {delivery.status === 'receiving' && (
        <>
          <span>📥 Đang nhận file... {delivery.progress}%</span>
          <div className="mini-progress">
            <div
              className="mini-progress-fill"
              style={{ width: `${delivery.progress}%` }}
            />
          </div>
        </>
      )}
      {delivery.status === 'decrypting' && <span>🔓 Đang giải mã...</span>}
      {delivery.status === 'done' && <span>✅ Tải xuống hoàn tất!</span>}
      {delivery.status === 'error' && (
        <span className="error">❌ {delivery.errorMessage}</span>
      )}
    </div>
  );
}
